import { API } from '../config/config';
import buildResponse from './helpers';

const UserService = {
  save: async (user) => API.post('/user', JSON.stringify(user))
    .then(
      (res) => {
        console.log(res);
        return buildResponse(res.data, res.status, res.statusText);
      },
    )
    .catch(
      (err) => err,
    ),
    getAll: (storeId) => getAll(storeId),
    getByAuthSub: (authSub) => getByAuthSub(authSub),
};

const getAll = async () => {
  try {
    var response = await API.get(`/users`)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err)
  }
}

const getByAuthSub = async (authSub) => {
  try {
    const response = await API.get(`/user?auth_sub=${encodeURIComponent(authSub)}`)
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    return null;
  }
}

export default UserService;
